/**
 * BB platform transaction fee — π %.
 *
 * "BB takes π % transaction fees for fixed costs and dev."
 *
 * This is the platform's cut on money that flows to a creator via Stripe
 * Connect (the `application_fee_amount`): digital sales, downloads, PWYW,
 * donations/sponsor, sync licences, and creator invoices. It funds BB's fixed
 * running costs (hosting, APIs, domains) and development.
 *
 * Note: print-on-demand / physical merch uses a separate, higher cut
 * (POD_PLATFORM_FEE_PERCENT) because that percentage also has to cover the real
 * printing + fulfillment cost — it is not pure platform margin, so it is NOT π.
 *
 * Single source of truth — import this everywhere the fee is computed so the
 * rate can never drift between routes.
 */

/** π percent ≈ 3.14159%. Used as `amount * (PLATFORM_FEE_PERCENT / 100)`. */
export const PLATFORM_FEE_PERCENT = Math.PI;

/** π / 100 ≈ 0.0314159 — the fee as a plain multiplier on an amount. */
export const PLATFORM_FEE_RATE = Math.PI / 100;

/** Human-readable label for UI / AI copy. */
export const PLATFORM_FEE_LABEL = 'π % (≈ 3.14%)';

/**
 * Fee in the SAME integer minor unit (e.g. cents) as `amount`.
 * Rounds to the nearest whole unit — Stripe's `application_fee_amount` must be
 * an integer.
 */
export function platformFee(amount: number): number {
  return Math.round(amount * PLATFORM_FEE_RATE);
}
